module.exports = __webpack_public_path__ + "static/media/center_piece.9f924833.png";